import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconAttachment(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4.99 10.023C4.388 10.685 4 11.576 4 12.5c0 .924.388 1.815.99 2.477C5.6 15.647 6.347 16 7 16h10v2H7c-1.347 0-2.6-.697-3.49-1.677C2.612 15.335 2 13.976 2 12.5s.612-2.835 1.51-3.823C4.4 7.697 5.653 7 7 7h10c1.36 0 2.6.268 3.526.941C21.5 8.651 22 9.717 22 11c0 1.283-.5 2.35-1.474 3.059C19.6 14.732 18.36 15 17 15H9c-.72 0-1.235-.477-1.514-.887A2.893 2.893 0 0 1 7 12.5c0-.6.185-1.17.486-1.613.28-.41.795-.887 1.514-.887h8v2H9.5s-.5 0-.5.5.5.5.5.5H17c1.14 0 1.9-.232 2.35-.559.4-.29.65-.724.65-1.441 0-.717-.25-1.15-.65-1.441C18.9 9.232 18.14 9 17 9H7c-.653 0-1.4.353-2.01 1.023Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
